import styled from 'styled-components';

import { colors, radius } from '../../../../../../styles/tokens';

export const Container = styled.div`
  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.md};
  padding: 24px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Item = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const IconBadge = styled.div`
  width: 36px;
  height: 36px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background-color: ${colors.surfaceContainerHighest};
`;

export const ItemText = styled.p`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.onSurface};

  span {
    font-weight: 400;
    color: ${colors.onSurfaceVariant};
  }
`;

export const ItemTime = styled.p`
  font-size: 11px;
  text-transform: uppercase;
  color: ${colors.onSurfaceVariant};
  margin-top: 4px;
`;

export const Empty = styled.p`
  font-size: 13px;
  color: ${colors.onSurfaceVariant};
`;
